import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";

import logo from "../assets/img/kuelly-logo-black.png";
import objetivoImg from "../assets/img/objetivo1.jpg";

export default function ObjetivoSection({
  logoSrc = logo,
  rightImage = objetivoImg,
  years = "X",
  site = "www.kuelly.com.mx",
}) {
  const KU_GREEN = "#2f5d35";

  return (
    <section className="position-relative overflow-hidden py-4 py-md-5">
      <style>{`
        .obj-wrap { position: relative; }
        /* cabecera */
        .obj-logo { width: 10rem; height: auto; }
        .obj-title {
          font-weight: 900;
          letter-spacing: .02em;
          line-height: 1.05;
          font-size: clamp(32px, 5.5vw, 60px);
        }
        .obj-title .green { color: ${KU_GREEN}; }

        /* viñetas X */
        .obj-x {
          display:inline-flex; align-items:center; justify-content:center;
          width:22px; height:22px; border-radius:50%;
          background:#0e0e0e; color:#fff; font-weight:800; margin-right:10px;
        }

        /* separar columnas sin “muro” negro */
        .obj-left p { max-width: 560px; }
        .obj-right { padding-left: 24px; }
        @media (max-width: 991.98px){ .obj-right { padding-left: 0; } }

        /* foto derecha */
        .obj-photo {
          width: 100%; height: auto;
          border: 3px solid ${KU_GREEN};
          box-shadow: 0 10px 24px rgba(0,0,0,.15);
        }

        /* franja inferior parcial */
        .obj-band {
          position: absolute; left: 0; bottom: 26px;
          width: 58%; background: ${KU_GREEN}; color: #fff; z-index: 2;
          padding: 12px 18px;
        }
        .obj-band .years {
          font-size: 40px; font-weight: 900; line-height: 1; margin-right: 12px;
        }
        .obj-site {
          position: absolute; right: 24px; bottom: 34px;
          color: #7d7d7d; font-weight: 600;
        }
        @media (max-width: 1199.98px){
          .obj-band { width: 66%; bottom: 20px; }
        }
        @media (max-width: 991.98px){
          .obj-band { width: 92%; left: 4%; bottom: 12px; }
          .obj-band .years { font-size: 34px; }
          .obj-site { position: static; display:block; text-align:right; margin-top: 8px; }
        }

        /* esquina verde decorativa (arriba-derecha) */
        .obj-corner {
          position:absolute; top:0; right:0; width:90px; height:90px; background:${KU_GREEN};
          clip-path: polygon(100% 0, 100% 100%, 0 0);
          opacity:.95;
        }
      `}</style>

      {/* esquina verde */}
      <div className="obj-corner" />

      <Container className="obj-wrap">
        {/* cabecera: logo + título */}
        <Row className="align-items-center g-3 mb-2">
          {/* Izquierda */}
          <Col xs={12} lg={6} className="obj-left">
            <Image src={logoSrc} alt="Kuelly" className="obj-logo" />
            <h1 className="obj-title m-0">
              NUESTRO <span className="green">OBJETIVO</span>
            </h1>
          </Col>

          {/* Derecha */}
          <Col xs={12} lg={6} className="obj-right">
            <div className="mb-2">
              <span className="obj-x">×</span>
              <strong>También Soñamos en</strong>
            </div>
            <p className="mb-3" style={{ maxWidth: 640 }}>
              Ser tu socio de confianza en el mundo de los bienes raíces. Desde
              2017, Kuelly se ha consolidado como una empresa de confianza en
              arrendamiento, comercialización y construcción, comprometida con
              la excelencia y la satisfacción de nuestros clientes.
            </p>
          </Col>
        </Row>

        {/* contenido */}
        <Row className="g-4 align-items-start">
          {/* Izquierda */}
          <Col xs={12} lg={6} className="obj-left">
            <div className="mb-2">
              <span className="obj-x">×</span>
              <strong>Targets</strong>
            </div>
            <div className="border-top mt-2 mb-3" style={{ opacity: 0.25 }} />
            <p className="mb-0">
              En Kuelly, nuestro compromiso es ofrecer un servicio excepcional y
              soluciones inmobiliarias a la medida. A través de nuestras áreas
              de arrendadora, comercializadora, constructora e inmobiliaria,
              buscamos superar tus expectativas y convertir tus proyectos en
              realidad.
            </p>
          </Col>

          {/* Derecha */}
          <Col xs={12} lg={6} className="obj-right">
            <Image
              src={rightImage}
              alt="Proyecto Kuelly"
              className="obj-photo"
            />
          </Col>
        </Row>
      </Container>

      {/* franja inferior + sitio */}
      <div className="obj-band">
        <div className="d-flex align-items-center">
          <div className="years">{String(years).toUpperCase()}</div>
          <div className="fw-semibold fs-5">años Construyendo Sueños</div>
        </div>
      </div>
      <span className="obj-site d-none d-lg-inline">{site}</span>
    </section>
  );
}
